export const getSegmentText = (text) => {
  const parts = text.split(/(~~.*?~~)/g);

  return parts.map((part) => {
    const isAlpa = /^~~.*~~$/.test(part);

    if (isAlpa) {
      return (
        <span
          key={part}
          data-title-alpha
          style={{ display: 'inline' }}
        >
          {part.slice(2, -2)}
        </span>
      );
    }

    return part;
  });
};
